import type { Module } from 'vuex';

/**
 * Nav: **All activities**. Reads the same `crm_activities` records the Opportunity recap tab owns, listed team-wide.
 *
 * Addresses as `crm/allActivities/<action>`, state at `state.crm.allActivities` (see store/index.ts).
 */
export interface AllActivitiesState {
    loading: boolean;
    error: string | null;
}

const defaultState = (): AllActivitiesState => ({
    loading: false,
    error: null,
});

export const allActivitiesModule: Module<AllActivitiesState, unknown> = {
    namespaced: true,
    state: defaultState,
    mutations: {
        SET_LOADING(state: AllActivitiesState, value: boolean): void {
            state.loading = value;
        },
        SET_ERROR(state: AllActivitiesState, message: string | null): void {
            state.error = message;
        },
    },
    actions: {},
    getters: {
        loading: (state: AllActivitiesState): boolean => state.loading,
        error: (state: AllActivitiesState): string | null => state.error,
    },
};
